module.exports = __webpack_public_path__ + "img/ok_cutline.a8f1218f.svg";